// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1L6HN","consentsList":"PatientConsents_consentsList__3yrLQ","consentsListEmpty":"PatientConsents_consentsListEmpty__2WZic"};